import { Textarea, TextareaProps } from '@mantine/core';
import { FieldRenderProps } from 'react-final-form';
import { GenericInput } from '../../models/generic';
import { InputWrapper } from './styles';
import { useTranslation } from 'react-i18next';
import { ErrorColor } from '../../styles/colors';
import { FC, ChangeEvent } from 'react';
import Icon from '../icon';

export interface TextAreaInputProps
  extends Omit<FieldRenderProps<string>, 'input'>,
    TextareaProps {
  afterChange?: (value: string) => void;
  input: GenericInput<string>;
}

export const TextAreaInput: FC<TextAreaInputProps> = ({
  input,
  meta,
  label,
  placeholder,
  description,
  afterChange,
  autosize = true,
  disabled,
  variant,
  maxRows,
  minRows = 4,
  required,
  ...rest
}) => {
  const { t } = useTranslation();

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    input.onChange(event.currentTarget.value);
    if (afterChange && typeof afterChange === 'function') {
      afterChange(event.currentTarget.value);
    }
  };

  const hasError = meta?.invalid && meta?.submitFailed;
  const rightSectionError = hasError ? <Icon icon="bold_xCircle" color={ErrorColor} size={1.25} /> : '';

  return (
    <InputWrapper hasError={hasError}>
      <Textarea
        {...rest}
        label={label}
        placeholder={placeholder}
        description={description}
        disabled={disabled}
        rightSection={rightSectionError}
        autosize={autosize}
        variant={variant}
        maxRows={maxRows}
        minRows={minRows}
        value={input.value}
        onChange={handleChange}
        error={hasError}
        required={required}
      />
    </InputWrapper>
  );
};

export default TextAreaInput;
